import { components, OptionProps } from 'react-select';

import { OptionTypeBase } from 'components/_core/form';
import TaxPeriod from 'features/Accounting/pages/Estimation/components/TaxPeriod';

const TaxForecastPeriodsOption = <TOptionType extends OptionTypeBase>(
  optionProps: OptionProps<TOptionType, false>,
) => (
  <components.Option {...optionProps} isSelected={false}>
    <TaxPeriod
      endsAt={optionProps.data.periodEndsAt}
      isPaid={optionProps.data.isPaid}
      payBefore={optionProps.data.payBefore}
      startsAt={optionProps.data.periodStartsAt}
    />
  </components.Option>
);

export default TaxForecastPeriodsOption;
